import { ChangeDetectionStrategy, Component } from '@angular/core';
import { QuestionInput } from '@player/+survey/question/question-input-base';
import { AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'input-checkbox',
  templateUrl: './input-checkbox.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, MatIcon],
})
export class InputCheckbox extends QuestionInput<boolean> {
  isChecked(): boolean {
    return this.answer == null ? this.defaultAnswer : (this.answer || 'false').toString() !== 'false';
  }

  get preparedAnswer() {
    return this.isChecked();
  }
}
